import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface ConfirmPamCodeChangePayload {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressType: string;
  latitude: string;
  longitude: string;
  pinCode: string;
  blockCode: string;
}

export async function confirmUpdateLocationWithPamCodeChangeAsync(
  addressId: number | string,
  payload: ConfirmPamCodeChangePayload,
  token: string,
  t: (key: string) => string
): Promise<any> {
  if (!navigator.onLine) {
    toast.error(t("internetConnection"), {
      toastId: "offline-error",
    });

    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/ConfirmUpdateAddressWithPamCodeChangeAsync?addressId=${addressId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    let responseData: any = null;

    try {
      responseData = await response.json();
    } catch {
      responseData = null;
    }

    if (!response.ok) {
      throw new Error(
        responseData?.message ||
          "Failed to update address with PAM code change"
      );
    }

    return responseData;
  } catch (error) {
    throw error;
  }
}